import AppDispatcher from '../dispatcher/AppDispatcher';
import MasterCardAlertConstants from '../constants/MasterCardAlertConstants';

const MasterCardAlertActionCreator = {
  saveNavigationReference(reference) {
    AppDispatcher.handleViewAction({
      actionType: MasterCardAlertConstants.NAVIGATION_REFERENCE,
      ref: reference,
    });
  },
  setManageAlertsAccountID(accountID) {
    AppDispatcher.handleViewAction({
      actionType: MasterCardAlertConstants.SET_MANAGE_ALERTS_ACCOUNT_ID,
      accountID,
    });
  },
};

export default MasterCardAlertActionCreator;
